module.exports = __webpack_public_path__ + "img/logo1-transparente.fbda7a4b.png";